// extracted by mini-css-extract-plugin
export default {"urlInput":"URLBox_urlInput__ppfr-"};